import React from "react";
import i18n from "../../i18n/i18n";
import notFoundPhoto from "../../images/not-found-photo.jpg";
import { withStyles } from 'tss-react/mui';
import {Typography} from "@mui/material";
import {withTranslation} from "react-i18next";

const styles = {
    root: {
        // set up a whole-width image
        position: "fixed",
        width: "100vw",
        height: "calc(100vh - 64px)", // HACK: magic value - toolbar height
        top: "64px", // HACK: magic value - toolbar height
        left: 0,

        backgroundImage: `url(${notFoundPhoto})`,
        backgroundSize: "cover",
        backgroundClip: "border-box",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#431E65",

        padding: "30px 10% 0",
        color: "white",
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "flex-start",
    },
    whiteText: {
        color: "#ffffff"
    }
};

class NotFoundPage extends React.Component {

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.root}>
                <Typography variant="h3" gutterBottom={true} className={classes.whiteText}>
                    {i18n.t("testNotFoundPage:header")}
                </Typography>
                <Typography variant="body1" className={classes.whiteText}>
                    {i18n.t("testNotFoundPage:message")}
                </Typography>
            </div>
        );
    }
}

const notFoundPageWithStyles = withStyles(NotFoundPage, styles)

export default withTranslation()(notFoundPageWithStyles);